import { useState, useEffect, createContext, useContext, ReactNode } from 'react'

import { useSessionContext } from 'hooks/SessionContext'

import Api from 'services/api'

const FeaturesContext = createContext<any>(null) // eslint-disable-line @typescript-eslint/no-explicit-any

export const FeaturesContextProvider = ({ children }: { children: ReactNode }) => {
  const { session: { dealerId } } = useSessionContext()

  const [enabledFeatures, setEnabledFeatures] = useState([])
  const [isEnabledFeaturesLoaded, setIsEnabledFeaturesLoaded] = useState(false)

  useEffect(() => {
    Api.FeatureCodes.enabledFeatures(dealerId)
      .then((res) => {
        setEnabledFeatures(res.features)
        setIsEnabledFeaturesLoaded(true)
      })
      .catch(() => {
        setEnabledFeatures([])
        setIsEnabledFeaturesLoaded(true)
      })
  }, [dealerId])

  return (
    <FeaturesContext.Provider value={{ enabledFeatures, isEnabledFeaturesLoaded }}>
      {children}
    </FeaturesContext.Provider>
  )
}

export const useFeaturesContext = () => useContext(FeaturesContext)
